import { properties } from '../selectors';

const getChannelIdByIndex = (state, chIndex) => {
  const { list } = properties(state);
  if (!list || chIndex < 0 || list.length <= chIndex) {
    return undefined;
  }
  return list[chIndex].id;
};

export { getChannelIdByIndex };
